<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { contract } from "../stores/index";

  onMount(() => {
    navigate(`/contracts/${$contract.id}/`);
  });
</script>
